import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ClipLoader from "react-spinners/ClipLoader";

const overlayStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(0, 0, 0, 0.5)',
  padding: '20px',
};

const textStyle = {
  color: '#fff',
  marginTop: '10px',
  marginBottom: 0,
};

const Loader = ({ loading = true, children }) => {
  return (
    <Fragment>
      {loading ? (
        <div style={overlayStyle}>
          <ClipLoader color={'#2D831F'} />
          <p style={textStyle}>Loading...</p>
        </div>
      ) : (
        children
      )}
    </Fragment>
  );
};

Loader.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
};

export default Loader;
